<template>
  <div>
    <!-- Desktop / Tablet Version -->
    <div class="bg">
      <v-col>
        <!-- Registration Card -->
        <v-row justify="center" class="ma-0 mx-6">
          <div class="white-card">
            <!-- Header Logo & Title -->
            <div class="card-header">
              <v-row justify="center">
                <img
                  height="150px"
                  class="mt-4"
                  src="../assets/images/logo.png"
                  alt="Logo"
                />
              </v-row>
              <v-row justify="center">
                <h1 class="blue-color text-center">REGISTER</h1>
              </v-row>
            </div>

            <!-- Scrollable Body: Steps Container -->
            <div class="card-body" ref="scrollWindow">
              <v-window
                v-model="step"
                transition="slide-x-transition"
                reverse-transition="slide-x-reverse-transition"
              >
                <!-- ===================== STEP 0: Select Account Type ===================== -->
                <v-window-item :value="0" class="step-content">
                  <v-col v-if="!userExists" class="pb-8" ref="targetElement">
                    <v-row justify="center" class="ma-0">
                      <h2 class="mt-2">Select Type of Account</h2>
                    </v-row>

                    <!-- Individual Card -->
                    <v-row justify="center" class="ma-0">
                      <v-card
                        @click="
                          accountType = 'Individual';
                          maxWindows = 1;
                        "
                        color="lightgrey"
                        :class="{ selected: accountType === 'Individual' }"
                        width="90%"
                        height="80px"
                        rounded
                        class="mt-2"
                        style="max-width: 400px"
                      >
                        <v-row
                          class="ma-0"
                          style="height: 100%"
                          justify="center"
                          align="center"
                        >
                          <h3>Individual</h3>
                        </v-row>
                      </v-card>
                    </v-row>

                    <!-- Business Card -->
                    <v-row justify="center" class="ma-0">
                      <v-card
                        @click="
                          accountType = 'Business';
                          maxWindows = 1;
                        "
                        color="lightgrey"
                        :class="{ selected: accountType === 'Business' }"
                        width="90%"
                        height="80px"
                        rounded
                        class="mt-4"
                        style="max-width: 400px"
                      >
                        <v-row
                          class="ma-0"
                          style="height: 100%"
                          justify="center"
                          align="center"
                        >
                          <h3>Business</h3>
                        </v-row>
                      </v-card>
                    </v-row>
                  </v-col>
                  <v-col v-if="userExists" class="pb-8">
                    <v-row justify="center" class="ma-0">
                      <h2 class="mt-2">Select an Action</h2>
                    </v-row>
                    <!-- Individual Card -->
                    <v-row justify="center" class="ma-0">
                      <v-card
                        @click="goNext()"
                        color="lightgrey"
                        width="90%"
                        height="80px"
                        rounded
                        class="mt-2"
                        style="max-width: 400px"
                      >
                        <v-row
                          class="ma-0"
                          style="height: 100%"
                          justify="center"
                          align="center"
                        >
                          <h3>Continue Registration</h3>
                        </v-row>
                      </v-card>
                    </v-row>

                    <!-- Business Card -->
                    <v-row justify="center" class="ma-0">
                      <v-card
                        @click="resetDialog = true"
                        color="lightgrey"
                        width="90%"
                        height="80px"
                        rounded
                        class="mt-4"
                        style="max-width: 400px"
                      >
                        <v-row
                          class="ma-0"
                          style="height: 100%"
                          justify="center"
                          align="center"
                        >
                          <h3>Create New Account</h3>
                        </v-row>
                      </v-card>
                    </v-row>
                  </v-col>
                </v-window-item>
                <!-- ===================== END STEP 0 ===================== -->

                <!-- ===================== STEP 1: Individual / Business Details ===================== -->
                <v-window-item :value="1" class="step-content">
                  <v-form ref="regForm">
                    <!-- Individual Header -->
                    <v-row
                      v-if="accountType === 'Individual'"
                      justify="center"
                      class="ma-0"
                      ref="targetElement"
                    >
                      <h3 class="my-4">INDIVIDUAL DETAILS</h3>
                    </v-row>
                    <!-- Business Header -->
                    <v-row
                      v-if="accountType === 'Business'"
                      justify="center"
                      class="ma-0"
                    >
                      <h3 class="mt-0 mb-4">BUSINESS DETAILS</h3>
                    </v-row>

                    <v-col class="pa-4">
                      <!-- Individual Fields -->
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Name"
                          v-model="newUser.name"
                          required
                          :rules="letterRules"
                        ></v-text-field>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Surname"
                          class="mt-4"
                          v-model="newUser.surname"
                          required
                          :rules="letterRules"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-select
                          dense
                          filled
                          rounded
                          label="Title"
                          class="mt-4"
                          v-model="newUser.title"
                          required
                          :rules="nullRules"
                          :items="titleOptions"
                        ></v-select>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-select
                          dense
                          filled
                          rounded
                          multiple
                          label="Qualifications"
                          class="mt-4"
                          v-model="newUser.qualifications"
                          :items="degreeOptions"
                        ></v-select>
                      </v-row>

                      <!-- Business Fields -->
                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Company Name"
                          class="mt-4"
                          v-model="newUser.companyName"
                          required
                          :rules="nullRules"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Practice Number"
                          class="mt-4"
                          v-model="newUser.practiceNumber"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Medical Practice Number"
                          class="mt-4"
                          v-model="newUser.medicalPracticeNumber"
                        ></v-text-field>
                      </v-row>

                      <!-- <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-select
                          dense
                          filled
                          rounded
                          label="Available Services"
                          class="mt-4"
                          v-model="newUser.availability"
                          :items="[
                            'Available(Callouts, Walkins & Online)',
                            'Available(Callouts & Walkins)',
                            'Available(Callouts & Online)',
                            'Available(Walkins & Online)',
                            'Callouts',
                            'Walkins',
                            'Online',
                            'Unavailable',
                          ]"
                          required
                          :rules="[
                            (v) => !!v || 'Please select available services',
                          ]"
                        ></v-select>
                      </v-row>-->

                      <!-- ID Number (if not business) -->
                      <v-row
                        v-if="accountType !== 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="ID Number"
                          class="mt-4"
                          v-model="newUser.idNumber"
                          required
                          :rules="nullRules"
                        ></v-text-field>
                      </v-row>

                      <!-- Date of Birth (if not business) -->
                      <v-row
                        v-if="accountType !== 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              filled
                              rounded
                              label="Date of Birth"
                              v-model="newUser.dateOfBirth"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              required
                              :rules="nullRules"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newUser.dateOfBirth"
                            @input="menu = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-row>

                      <!-- Email Address -->
                      <v-row v-if="!userExists" justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Email Address"
                          type="email"
                          autocapitalize="off"
                          autocorrect="off"
                          spellcheck="false"
                          class="mt-4"
                          v-model="newUser.email"
                          required
                          :rules="emailRules"
                        ></v-text-field>
                      </v-row>

                      <!-- Confirm Email Address -->
                      <v-row v-if="!userExists" justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          type="email"
                          autocapitalize="off"
                          autocorrect="off"
                          spellcheck="false"
                          label="Confirm Email Address"
                          class="mt-4"
                          v-model="newUser.confirmEmail"
                          required
                          :rules="emailRules"
                        ></v-text-field>
                      </v-row>

                      <!-- Cell Number -->
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Cell Number"
                          class="mt-4"
                          v-model="newUser.CellNo"
                          required
                          :rules="contactRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Alternative Number"
                          class="mt-4"
                          v-model="newUser.alternativeNumber"
                          :rules="contactRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Landline Number"
                          class="mt-4"
                          v-model="newUser.landline"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-select
                          multiple
                          dense
                          filled
                          rounded
                          v-model="newUser.profession"
                          :items="professions"
                          :item-text="(item) => item.name"
                          :item-value="(item) => item.name"
                          label="Profession"
                          required
                          :rules="nullRules"
                        ></v-select>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Owner Name"
                          v-model="newUser.ownerName"
                        ></v-text-field>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Owner Surname"
                          class="mt-4"
                          v-model="newUser.ownerSurname"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType == 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Owner ID Number"
                          class="mt-4"
                          v-model="newUser.ownerIDNumber"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Owner Number"
                          class="mt-4"
                          v-model="newUser.ownerNumber"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Owner Email Address"
                          class="mt-4"
                          v-model="newUser.ownerEmail"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType == 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Contact Person"
                          class="mt-4"
                          v-model="newUser.contactPerson"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="center" class="ma-0">
                        <v-autocomplete
                          :items="countries"
                          item-text="name"
                          return-object
                          dense
                          filled
                          rounded
                          label="Country"
                          v-model="newUser.country"
                          :rules="nullRules"
                          required
                        ></v-autocomplete>
                      </v-row>

                      <!-- Business-Specific Fields -->
                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="City"
                          class="mt-4"
                          v-model="newUser.city"
                        ></v-text-field>
                      </v-row>

                      <!-- Province -->
                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Province"
                          class="mt-4"
                          v-model="newUser.province"
                        ></v-text-field>
                      </v-row>

                      <!-- Postal Code -->
                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Postal Code"
                          class="mt-4"
                          v-model="newUser.postalCode"
                        ></v-text-field>
                      </v-row>

                      <!-- Gender Selection (if Individual) -->
                      <v-row
                        v-if="accountType !== 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-col cols="6" class="pa-0">
                          <v-card
                            @click="setGender('Male')"
                            color="lightgrey"
                            :class="{ selected: gender === 'Male' }"
                            width="90%"
                            height="50px"
                            rounded
                            class="my-2"
                          >
                            <v-row
                              class="ma-0"
                              style="height: 100%"
                              justify="center"
                              align="center"
                            >
                              <h3>Male</h3>
                            </v-row>
                          </v-card>
                        </v-col>
                        <v-col cols="6" class="pa-0">
                          <v-card
                            @click="setGender('Female')"
                            color="lightgrey"
                            :class="{ selected: gender === 'Female' }"
                            width="90%"
                            height="50px"
                            rounded
                            class="my-2"
                          >
                            <v-row
                              class="ma-0"
                              style="height: 100%"
                              justify="center"
                              align="center"
                            >
                              <h3>Female</h3>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <ZAAddressAutocomplete
                          required
                          :rules="nullRules"
                          dense
                          filled
                          rounded
                          class="mt-4"
                          label="Business Physical Address"
                          v-model="newUser.address"
                          :return-object="true"
                          :lat.sync="newUser.latitude"
                          :lon.sync="newUser.longitude"
                        />
                      </v-row>

                      <!-- Address -->
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <ZAAddressAutocomplete
                          required
                          :rules="nullRules"
                          dense
                          filled
                          rounded
                          class="mt-4"
                          label="Home Physical Address"
                          v-model="newUser.address"
                          :return-object="true"
                          :lat.sync="newUser.latitude"
                          :lon.sync="newUser.longitude"
                        />
                      </v-row>

                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <ZAAddressAutocomplete
                          required
                          :rules="nullRules"
                          dense
                          filled
                          rounded
                          class="mt-4"
                          label="Business Practice Address"
                          v-model="newUser.businessAddress"
                          :return-object="true"
                          :lat.sync="newUser.businessLatitude"
                          :lon.sync="newUser.businessLongitude"
                        />
                      </v-row>

                      <v-row justify="center" class="ma-0">
                        <v-textarea
                          dense
                          filled
                          rounded
                          label="Bio(Personal Info, Qualifications, Strenths)"
                          v-model="newUser.bio"
                          class="mt-4"
                        ></v-textarea>
                      </v-row>
                      <v-row v-if="!userExists" justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Password"
                          v-model="newUser.password"
                          class="mt-4"
                          required
                          :rules="passwordRules"
                          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show ? 'text' : 'password'"
                          @click:append="show = !show"
                        ></v-text-field>
                      </v-row>

                      <!-- Confirm Password -->
                      <v-row v-if="!userExists" justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show ? 'text' : 'password'"
                          @click:append="show = !show"
                          label="Confirm Password"
                          v-model="newUser.confirmPassword"
                          class="mt-4"
                          required
                          :rules="passwordRules"
                        ></v-text-field>
                      </v-row>

                      <v-row
                        v-if="accountType === 'Business'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-select
                          dense
                          filled
                          rounded
                          :items="hearAboutUsOptions"
                          label="How did you hear about us?"
                          v-model="newUser.hearAboutUs"
                          multiple
                        ></v-select>
                      </v-row>

                      <!-- Individual Fields -->
                      <!-- T&Cs Dialog -->
                      <v-dialog
                        v-model="showTnCDialog"
                        persistent
                        max-width="600px"
                      >
                        <v-card>
                          <v-card-title class="headline"
                            >Terms & Conditions</v-card-title
                          >
                          <v-card-text
                            style="max-height: 300px; overflow-y: auto"
                          >
                            <div style="white-space: pre-line">
                              <b>WEBSITE AND APPLICATION TERMS OF USE</b>
                              <br />for Lotus Life (Pty) Ltd <br />Compilation
                              Date: 19 March 2025 <br />© 2025 Lotus Life (Pty)
                              Ltd
                              <br />
                              <br />
                              <b>1. Introduction</b>
                              <br />Welcome to the Lotus App and Website
                              ("Platform"). These Terms and Conditions ("Terms")
                              govern the access and use of the Lotus App ("App")
                              and Lotus Website ("Website") by medical
                              practitioners ("Practitioners") and users
                              ("Users"). By using the Platform, you agree to
                              these Terms. If you do not agree, you must refrain
                              from using the Platform.
                              <br />
                              <br />
                              <b>2. Definitions</b>
                              <br />Application means the Lotus App, a digital
                              platform facilitating medical consultations via
                              text, voice, video, and home visits. <br />Website
                              means the online platform operated by Lotus at
                              https://lotusl.co.za/ <br />Practitioner means a
                              licensed medical professional registered with the
                              relevant regulatory authority. <br />User means
                              any person accessing the Platform to seek medical
                              consultation. <br />Services mean
                              healthcare-related consultations, guidance, and
                              home visits facilitated through the Platform.
                              <br />Personal Information means any data that
                              identifies a User or Practitioner, as defined
                              under POPIA.
                              <br />
                              <br />
                              <b>3. Eligibility and Registration</b>
                              <br />Practitioners must: <br />- Hold a valid and
                              legal medical license recognized by their
                              jurisdiction. <br />- Provide accurate and
                              up-to-date registration details. <br />- Ensure
                              compliance with their country's medical laws,
                              including any telemedicine regulations.
                              <br />Lotus reserves the right to verify such
                              credentials. <br />Users must: <br />- Be at least
                              18 years old. <br />- Provide truthful and
                              accurate health information. <br />The Lotus App
                              reserves the right to verify credentials and
                              approve or deny registration at its sole
                              discretion. <br />By registering as a
                              Practitioner, the Practitioner expressly grants
                              Lotus permission to conduct background checks,
                              including verification of professional
                              qualifications and screening for any criminal
                              records. Lotus reserves the right to deny or
                              terminate access if any disqualifying information
                              is found.
                              <br />
                              <br />
                              <b>4. Services Provided</b>
                              <br />Practitioners may offer the following:
                              <br />- Text Consultation: Messaging-based medical
                              advice. <br />- Voice Consultation: Audio-based
                              consultations. <br />- Video Consultation: Virtual
                              medical sessions via video. <br />- Home Visits:
                              In-person consultations at a User's residence.
                              <br />Disclaimer: Virtual consultations may not
                              substitute in-person medical assessments where
                              required. Users must seek immediate emergency care
                              if needed.
                              <br />
                              <br />
                              <b>5. Fees and Payments</b>
                              <br />- Users will pay for services via the
                              Platform's designated payment system. <br />- The
                              Platform may deduct service fees or commissions,
                              as specified in the fee structure. <br />- No
                              refunds will be provided for completed services
                              unless otherwise required under South African
                              Consumer Protection Act (CPA). <br />-
                              Practitioners are responsible for any applicable
                              taxes on their earnings.
                              <br />
                              <br />
                              <b>
                                6. Protection of Personal Information (POPIA
                                Compliance)
                              </b>
                              <br />- User and Practitioner data is collected,
                              processed, and stored in compliance with the
                              Protection of Personal Information Act (POPIA).
                              <br />Data Processing: <br />- User data is
                              processed with consent and only for medical
                              consultation purposes. <br />- Practitioners must
                              maintain confidentiality in compliance with
                              medical privacy laws. <br />User Rights:
                              <br />Users may: <br />- Request access to their
                              data. <br />- Withdraw consent for data
                              processing. <br />- Request data correction or
                              deletion, unless retention is required by law.
                              <br />Third-Party Data Sharing: <br />- Data will
                              not be shared with third parties except: <br />-
                              Where legally required. <br />- For payment
                              processing and service facilitation (e.g.,
                              third-party telemedicine providers). <br />For
                              more details, refer to Lotus' Privacy Policy.
                              <br />
                              <br />
                              <b>7. Liability and Indemnification</b>
                              <br />The Platform only facilitates medical
                              services and is not liable for: <br />- Medical
                              advice provided by Practitioners. <br />- Any
                              misdiagnosis, malpractice, or negligence. <br />-
                              Errors arising from incomplete or inaccurate
                              information provided by Users. <br />Practitioner
                              Responsibility: <br />- Practitioners fully
                              indemnify Lotus App from any claims arising from:
                              <br />- Breach of medical ethics or regulatory
                              laws. <br />- Medical malpractice or incorrect
                              treatment. <br />Platform Limitation of Liability:
                              <br />- To the extent permitted by law, Lotus is
                              not liable for: <br />- Any loss, injury, or
                              damages resulting from service use. <br />-
                              Platform downtime or unavailability due to
                              technical issues.
                              <br />
                              <br />
                              <b>8. Suspension and Termination</b>
                              <br />The Platform may suspend or terminate access
                              if: <br />- A Practitioner or User violates these
                              Terms or relevant laws. <br />- A Practitioner
                              provides false credentials or engages in unethical
                              behavior. <br />Practitioners and Users may
                              terminate their use by providing written notice.
                              <br />
                              <br />
                              <b>9. Compliance with South African Law</b>
                              <br />- These Terms are governed by South African
                              law. However, Users and Practitioners outside
                              South Africa must comply with the applicable laws
                              and regulations of their jurisdiction, including
                              but not limited to medical practice, data
                              protection, and telemedicine laws. <br />- The
                              Platform does not guarantee compliance with
                              international regulations unless expressly stated.
                              <br />
                              <br />
                              <b>10. Jurisdiction</b>
                              <br />- Any disputes shall be governed by the laws
                              of South Africa. <br />- South African courts have
                              exclusive jurisdiction over legal matters relating
                              to these Terms.
                              <br />
                              <br />
                              <b>11. Dispute Resolution</b>
                              <br />Negotiation & Arbitration <br />- Parties
                              agree to resolve disputes amicably through
                              negotiation. <br />- If unresolved, disputes will
                              be referred to binding arbitration under the rules
                              of the Arbitration Foundation of Southern Africa
                              (AFSA).
                              <br />
                              <br />
                              <b>12. Intellectual Property Rights</b>
                              <br />- All Intellectual Property Rights,
                              including trademarks, domain names, and content on
                              the Platform, belong to Lotus. <br />- Users and
                              Practitioners may not reproduce, distribute, or
                              modify Platform content without prior consent.
                              <br />
                              <br />
                              <b>13. Amendments</b>
                              <br />- The Platform reserves the right to update
                              these Terms at any time. Continued use constitutes
                              acceptance of revised Terms.
                              <br />
                            </div>
                            <v-checkbox
                              v-model="tncAccepted"
                              label="I accept the Terms & Conditions"
                              class="mt-4"
                            ></v-checkbox>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              :disabled="!tncAccepted"
                              color="primary"
                              @click="showTnCDialog = false"
                              >Accept</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <!-- End T&Cs Dialog -->
                    </v-col>
                  </v-form>
                </v-window-item>
                <!-- ===================== END STEP 1 ===================== -->

                <v-window-item :value="2" class="step-content">
                  <v-col class="pa-0 px-4">
                    <v-row
                      justify="start"
                      class="ma-0 mt-4"
                      ref="targetElement"
                    >
                      <h2>Certification</h2>
                    </v-row>
                    <v-expansion-panels
                      v-if="accountType == 'Business'"
                      style="max-height: 40vh; overflow-y: scroll"
                    >
                      <v-expansion-panel
                        v-for="(section, index) in requiredCompanyDocs"
                        :key="index"
                        @click="togglePanel(index)"
                      >
                        <v-expansion-panel-header class="panel-header">
                          {{ section.title }}
                          <h4 v-if="newUser[section.key]">
                            ({{ newUser[section.key].length }})
                          </h4>
                          <h4 v-else>(0)</h4>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row justify="center">
                            <v-col cols="12" md="6">
                              <v-row justify="start" class="ma-0">
                                <h3>PDF Name</h3>
                              </v-row>
                              <v-row justify="start" class="ma-0">
                                <v-text-field
                                  dense
                                  v-model="certificateName"
                                  outlined
                                  filled
                                  class="mt-4"
                                  placeholder="PDF Name"
                                  style="max-width: 400px"
                                ></v-text-field>
                              </v-row>
                              <v-row justify="start" class="ma-0">
                                <h3>Expiry Date</h3>
                              </v-row>
                              <v-row justify="start" class="ma-0">
                                <v-text-field
                                  dense
                                  v-model="certificateExpiry"
                                  outlined
                                  filled
                                  class="mt-4"
                                  placeholder="Expiry Date"
                                  style="max-width: 400px"
                                ></v-text-field>
                              </v-row>
                              <v-row justify="start" class="ma-0">
                                <h3>Document</h3>
                                <h4 class="mt-1 mx-2" style="color: grey">
                                  Please Use PDF
                                </h4>
                              </v-row>
                              <v-row class="ma-0" justify="start">
                                <v-file-input
                                  ref="fileInput"
                                  solo
                                  dense
                                  rounded
                                  dark
                                  :clearable="false"
                                  hide-details="true"
                                  :prepend-icon="false"
                                  background-color="#e022d1"
                                  v-model="file1"
                                  class="mb-4"
                                  @change="addDoc($event, section)"
                                  label="Upload File"
                                  style="max-width: 240px"
                                ></v-file-input>
                              </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-row justify="start" class="ma-0">
                                <h3>Document(s) Added</h3>
                              </v-row>
                              <v-row
                                v-show="
                                  newUser[section.key] &&
                                  newUser[section.key][0]
                                "
                                v-for="(doc, index) in newUser[section.key]"
                                :key="index"
                              >
                                <v-col cols="12" class="pa-0">
                                  <h4
                                    class="mx-4 pointer"
                                    @click="viewDoc(doc.document)"
                                  >
                                    - {{ doc.name }}({{ doc.expiryDate }})
                                  </h4>
                                </v-col>
                                <v-col cols="12" class="pa-0">
                                  <h4
                                    class="mx-6 pointer"
                                    style="color: #4390c0"
                                    @click="
                                      selectedSection = section;
                                      deleteIndex = index;
                                      deleteDocDialog = true;
                                    "
                                  >
                                    Remove
                                  </h4>
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="
                                  !newUser[section.key] ||
                                  !newUser[section.key][0]
                                "
                              >
                                <h4 class="mx-4" style="color: #4390c0">
                                  No certificate(s) added yet
                                </h4>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <v-expansion-panels
                      v-if="accountType == 'Individual'"
                      style="max-height: 40vh; overflow-y: scroll"
                    >
                      <v-expansion-panel
                        v-for="(section, index) in requiredDocs"
                        :key="index"
                        @click="togglePanel(index)"
                      >
                        <v-expansion-panel-header class="panel-header">
                          {{ section.title }}
                          <h4 v-if="newUser[section.key]">
                            ({{ newUser[section.key].length }})
                          </h4>
                          <h4 v-else>(0)</h4>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row justify="center">
                            <v-col cols="12" md="6">
                              <v-row justify="start" class="ma-0">
                                <h3>PDF Name</h3>
                              </v-row>
                              <v-row justify="start" class="ma-0">
                                <v-text-field
                                  dense
                                  v-model="certificateName"
                                  outlined
                                  filled
                                  class="mt-4"
                                  placeholder="PDF Name"
                                  style="max-width: 400px"
                                ></v-text-field>
                              </v-row>
                              <v-row justify="start" class="ma-0">
                                <h3>Expiry Date</h3>
                              </v-row>
                              <v-row justify="start" class="ma-0">
                                <v-text-field
                                  dense
                                  v-model="certificateExpiry"
                                  outlined
                                  filled
                                  class="mt-4"
                                  placeholder="Expiry Date"
                                  style="max-width: 400px"
                                ></v-text-field>
                              </v-row>
                              <v-row justify="start" class="ma-0">
                                <h3>Document</h3>
                                <h4 class="mt-1 mx-2" style="color: grey">
                                  Please Use PDF
                                </h4>
                              </v-row>
                              <v-row class="ma-0" justify="start">
                                <v-file-input
                                  ref="fileInput"
                                  solo
                                  dense
                                  rounded
                                  dark
                                  :clearable="false"
                                  hide-details="true"
                                  :prepend-icon="false"
                                  background-color="#e022d1"
                                  v-model="file1"
                                  class="mb-4"
                                  @change="addDoc($event, section)"
                                  label="Upload File"
                                  style="max-width: 240px"
                                ></v-file-input>
                              </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-row justify="start" class="ma-0">
                                <h3>Document(s) Added</h3>
                              </v-row>
                              <v-row
                                v-show="
                                  newUser[section.key] &&
                                  newUser[section.key][0]
                                "
                                v-for="(doc, index) in newUser[section.key]"
                                :key="index"
                              >
                                <v-col cols="12" class="pa-0">
                                  <h4
                                    class="mx-4 pointer"
                                    @click="viewDoc(doc.document)"
                                  >
                                    - {{ doc.name }}({{ doc.expiryDate }})
                                  </h4>
                                </v-col>
                                <v-col cols="12" class="pa-0">
                                  <h4
                                    class="mx-6 pointer"
                                    style="color: #4390c0"
                                    @click="
                                      selectedSection = section;
                                      deleteIndex = index;
                                      deleteDocDialog = true;
                                    "
                                  >
                                    Remove
                                  </h4>
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="
                                  !newUser[section.key] ||
                                  !newUser[section.key][0]
                                "
                              >
                                <h4 class="mx-4" style="color: #4390c0">
                                  No certificate(s) added yet
                                </h4>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <!-- <v-row v-if="accountType == 'Individual'" justify="start" class="ma-0 mt-4">
                      <v-btn v-if="!newUser.clearanceRequested" @click="requestingClearance = true" color="#4390c0" dark
                        rounded width="240px">
                        Request Criminal Check
                      </v-btn>
                      <h4 class="mt-4 blue-color" v-if="newUser.clearanceRequested">
                        A request for a criminal check from Lotus has been requested...
                      </h4>
                    </v-row>-->
                  </v-col>
                </v-window-item>

                <v-window-item v-if="step > 2" :value="3" class="step-content">
                  <v-form ref="medicalForm">
                    <v-col class="px-4">
                      <v-row class="ma-0" justify="center" ref="targetElement">
                        <div class="avatar-upload">
                          <!-- Clicking the label triggers the hidden file input -->
                          <label
                            @click.prevent="openFilePicker"
                            class="avatar-label"
                          >
                            <div
                              v-if="newUser && newUser.profilePhoto"
                              class="avatar-preview"
                            >
                              <img
                                :src="newUser.profilePhoto.url"
                                alt="Preview"
                              />
                            </div>
                            <div v-else class="avatar-placeholder">
                              Tap to upload or take a selfie
                            </div>
                          </label>

                          <!-- Hidden file input -->
                          <input
                            ref="fileInput"
                            type="file"
                            accept="image/*"
                            @change="onFileChange"
                            style="display: none"
                          />
                        </div>
                      </v-row>
                      <!-- Profession Selection for Individual -->
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <h3 class="my-4">WHAT IS YOUR PROFESSION?</h3>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-select
                          multiple
                          dense
                          filled
                          rounded
                          v-model="newUser.profession"
                          :items="professions"
                          :item-text="(item) => item.name"
                          :item-value="(item) => item.name"
                          label="Select Profession"
                          required
                          :rules="nullRules"
                          class="mt-0"
                        ></v-select>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <h3 class="my-4">WHAT DO YOU SPECIALISE IN?</h3>
                        <v-btn
                          class="mx-2 my-3"
                          dark
                          @click="addingSpeciality = true"
                          color="#4390c0"
                          >Add Speciality</v-btn
                        >
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-select
                          @change="removeSpeciality()"
                          multiple
                          dense
                          filled
                          rounded
                          v-model="newUser.speciality"
                          :items="specialities"
                          label="Select Speciality"
                          class="mt-0"
                        ></v-select>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <h3 class="my-4 text-center">
                          WHAT MEDICAL AID ARE YOU ASSOCIATED WITH?
                        </h3>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-select
                          dense
                          filled
                          rounded
                          v-model="newUser.medicalAid"
                          :items="medicalAids"
                          label="Select Medical Aid"
                          required
                          :rules="nullRules"
                          class="mt-0"
                          multiple
                        ></v-select>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <h3 class="my-4 text-center">
                          WHAT IS YOUR MEDICAL LICENSE NUMBER?
                        </h3>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                      >
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Medical License Number"
                          class="mt-4"
                          v-model="newUser.medicalLicenseNumber"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                        style="margin-top: 24px"
                      >
                        <h3 class="text-center">
                          WHAT IS YOUR CLIENT PREFERENCE?
                        </h3>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="start"
                        class="ma-0"
                      >
                        <v-select
                          multiple
                          class="textfield"
                          label="Client Preference"
                          v-model="newUser.clientPreference"
                          dense
                          filled
                          rounded
                          required
                          :rules="nullRules"
                          :items="preferences"
                        ></v-select>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="center"
                        class="ma-0"
                        style="margin-top: 24px"
                      >
                        <h3 class="text-center">
                          WHAT IS YOUR CLIENT AGE PREFERENCE?
                        </h3>
                      </v-row>
                      <v-row
                        v-if="accountType === 'Individual'"
                        justify="start"
                        class="ma-0 mx-2"
                      >
                        <v-range-slider
                          :readonly="readOnly"
                          v-model="newUser.clientAgePreference"
                          :max="max"
                          :min="min"
                          hide-details
                        >
                          <template v-slot:prepend>
                            <v-text-field
                              :value="newUser.clientAgePreference[0]"
                              class="mt-0 pt-0"
                              hide-details
                              single-line
                              type="number"
                              style="width: 60px"
                              @input="
                                $set(
                                  newUser.clientAgePreference,
                                  0,
                                  Number($event),
                                )
                              "
                            ></v-text-field>
                          </template>

                          <template v-slot:append>
                            <v-text-field
                              :value="newUser.clientAgePreference[1]"
                              class="mt-0 pt-0"
                              hide-details
                              single-line
                              type="number"
                              style="width: 60px"
                              @input="
                                $set(
                                  newUser.clientAgePreference,
                                  1,
                                  Number($event),
                                )
                              "
                            ></v-text-field>
                          </template>
                        </v-range-slider>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-window-item>

                <!-- ===================== STEP 4: Vehicle Details ===================== -->
                <v-window-item
                  v-if="accountType === 'Individual'"
                  :value="4"
                  class="step-content"
                >
                  <v-form ref="vehicleForm">
                    <v-row justify="center" ref="targetElement">
                      <h3 class="my-4">VEHICLE DETAILS</h3>
                    </v-row>
                    <v-row
                      justify="center"
                      align="center"
                      class="fill-height ma-0"
                    >
                      <v-col class="pa-4">
                        <v-row justify="center">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Vehicle Make"
                            class="mt-8"
                            v-model="newUser.vehicleMake"
                          ></v-text-field>
                        </v-row>
                        <v-row justify="center">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Vehicle Model"
                            class="mt-4"
                            v-model="newUser.vehicleModel"
                          ></v-text-field>
                        </v-row>
                        <v-row justify="center">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Year"
                            class="mt-4"
                            v-model="newUser.vehicleYear"
                            :rules="numberRulesNR"
                          ></v-text-field>
                        </v-row>
                        <v-row justify="center">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Colour"
                            class="mt-4"
                            v-model="newUser.vehicleColour"
                            :rules="letterRulesNR"
                          ></v-text-field>
                        </v-row>
                        <v-row justify="center">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Registration"
                            class="mt-4"
                            v-model="newUser.vehicleReg"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-window-item>
                <!-- ===================== END STEP 4 ===================== -->

                <!-- ===================== STEP 5: Select Language ===================== -->
                <v-window-item
                  v-if="accountType === 'Individual'"
                  :value="5"
                  class="step-content"
                >
                  <v-col class="px-4">
                    <v-row justify="center" ref="targetElement">
                      <h3 class="mt-6 mb-4">SELECT LANGUAGE</h3>
                    </v-row>
                    <v-row justify="center" class="ma-0 language-grid">
                      <v-col
                        v-for="lang in [
                          'English',
                          'Afrikaans',
                          'Zulu',
                          'Tswana',
                          'Xhosa',
                          'Sotho',
                          'isiNdebele',
                          'Sepedi',
                          'siSwati',
                          'Tshivenda',
                          'Xitsonga',
                        ]"
                        :key="lang"
                        cols="auto"
                        class="d-flex justify-center"
                      >
                        <v-card
                          @click="selectItem(lang)"
                          color="lightgrey"
                          :class="{
                            selected: languages.includes(lang),
                          }"
                          class="language-card pa-2"
                        >
                          <v-row
                            class="ma-0"
                            style="height: 100%"
                            justify="center"
                            align="center"
                          >
                            <h3 class="m-0">{{ lang }}</h3>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-window-item>
                <!-- ===================== END STEP 5 ===================== -->

                <!-- ===================== STEP 6: Add Social Links ===================== -->
                <v-window-item
                  v-if="accountType === 'Individual'"
                  :value="6"
                  class="step-content"
                >
                  <v-col class="px-4">
                    <v-row justify="center" ref="targetElement">
                      <h3 class="mt-4">ADD SOCIAL LINKS</h3>
                    </v-row>
                    <v-row justify="center" class="ma-0">
                      <v-text-field
                        dense
                        filled
                        rounded
                        label="Instagram"
                        class="mt-8"
                        v-model="newUser.instagramUrl"
                      ></v-text-field>
                    </v-row>
                    <v-row justify="center" class="ma-0">
                      <v-text-field
                        dense
                        filled
                        rounded
                        label="Facebook"
                        v-model="newUser.facebookUrl"
                      ></v-text-field>
                    </v-row>
                    <v-row justify="center" class="ma-0">
                      <v-text-field
                        dense
                        filled
                        rounded
                        label="Linked In"
                        v-model="newUser.linkedInUrl"
                      ></v-text-field>
                    </v-row>
                    <v-row justify="center" class="ma-0">
                      <v-select
                        dense
                        filled
                        rounded
                        :items="hearAboutUsOptions"
                        label="How did you hear about us?"
                        v-model="newUser.hearAboutUs"
                        multiple
                      ></v-select>
                    </v-row>
                  </v-col>
                </v-window-item>
                <!-- ===================== END STEP 6 ===================== -->

                <!-- ===================== STEP 7: Consultation Fee ===================== -->
                <v-window-item
                  v-if="accountType === 'Individual'"
                  :value="7"
                  class="step-content"
                >
                  <v-form ref="feeForm">
                    <v-row justify="center" class="ma-0" ref="targetElement">
                      <h3 class="mt-4 text-center">
                        CONSULTATION FEE(25% service charge will be added to the
                        rates)
                      </h3>
                    </v-row>
                    <v-col class="px-4">
                      <v-row justify="start" class="ma-0">
                        <h3 class="mt-4 my-3 text-center">
                          Callout Fee within a 5km radius(Per Hr)
                        </h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Callout Fee (5km)"
                          v-model="newUser.calloutFee"
                          class="mt-0"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="start" class="ma-0">
                        <h3 class="mt-4 my-3 text-center">
                          Callout Fee within a 10km radius(Per Hr)
                        </h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Callout Fee (10km)"
                          v-model="newUser.calloutFee10km"
                          class="mt-0"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="start" class="ma-0">
                        <h3 class="mt-4 my-3 text-center">
                          Callout Fee within a 15km radius(Per Hr)
                        </h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Callout Fee (15km)"
                          v-model="newUser.calloutFee15km"
                          class="mt-0"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="start" class="ma-0">
                        <h3 class="my-3 text-center">
                          Online Consultation Fee 30 Mins
                        </h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Online Consultation 30 Mins"
                          v-model="newUser.onlineFee30"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="start" class="ma-0">
                        <h3 class="my-3 text-center">
                          Online Consultation Fee 45 Mins
                        </h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Online Consultation 45 Mins"
                          v-model="newUser.onlineFee45"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="center" justify-md="start" class="ma-0">
                        <h3 class="my-3 text-center">
                          Online Consultation Fee 1 Hr
                        </h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Online Consultation 1 Hr"
                          v-model="newUser.onlineFee60"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-window-item>

                <v-window-item
                  v-if="accountType === 'Individual'"
                  :value="8"
                  class="step-content"
                >
                  <v-form ref="bankingForm">
                    <v-row justify="center" class="ma-0" ref="targetElement">
                      <h3 class="mt-4">BANKING DETAILS</h3>
                    </v-row>
                    <v-col class="px-4">
                      <v-row justify="start" class="ma-0">
                        <h3 class="mt-4 my-3">Bank Name</h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Bank Name"
                          v-model="newUser.bankName"
                          class="mt-0"
                          required
                          :rules="letterRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="start" class="ma-0">
                        <h3 class="my-3">Account Number</h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Account Number"
                          v-model="newUser.accountNumber"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="start" class="ma-0">
                        <h3 class="my-3">Branch Code</h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-text-field
                          dense
                          filled
                          rounded
                          label="Branch Code"
                          v-model="newUser.branchCode"
                          required
                          :rules="numberRules"
                        ></v-text-field>
                      </v-row>

                      <v-row justify="start" class="ma-0">
                        <h3 class="my-3">Account Type</h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-select
                          dense
                          filled
                          rounded
                          label="Account Type"
                          v-model="newUser.bankAccountType"
                          :items="accountTypes"
                          required
                          :rules="nullRules"
                        ></v-select>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-window-item>
                <!-- ===================== END STEP 7 ===================== -->
                <!-- ===================== Business Registration Steps ===================== -->
                <template v-if="accountType === 'Business'">
                  <!-- Medical Aid -->
                  <v-window-item :value="3" class="step-content">
                    <v-form ref="businessMedicalForm">
                      <v-row justify="center" class="ma-0" ref="targetElement">
                        <h3 class="my-4">
                          WHAT MEDICAL AID ARE YOU ASSOCIATED WITH?
                        </h3>
                      </v-row>
                      <v-row justify="center" class="ma-0">
                        <v-select
                          dense
                          filled
                          rounded
                          v-model="newUser.medicalAid"
                          :items="medicalAids"
                          label="Select Medical Aid"
                          required
                          :rules="[
                            (v) =>
                              (!!v && v.length > 0) ||
                              'Please select at least one medical aid',
                          ]"
                          class="mt-0"
                          multiple
                        ></v-select>
                      </v-row>
                      <v-col class="pa-0" v-if="accountType == 'Business'">
                        <v-row
                          class="ma-0 mx-2"
                          justify="center"
                          justify-md="center"
                        >
                          <h3 class="mb-2">COMPANY VEHICLES</h3>
                          <v-icon
                            @click="addVehicle()"
                            color="#4390c0"
                            class="mb-2 mx-2"
                            >mdi-plus-box</v-icon
                          >
                        </v-row>
                        <v-row
                          v-if="newUser.vehicles && newUser.vehicles[0]"
                          justify="start"
                          class="ma-0"
                        >
                          <v-col
                            cols="12"
                            sm="6"
                            md="6"
                            v-for="(vehicle, index) in newUser.vehicles"
                            :key="vehicle"
                          >
                            <v-card
                              width="100%"
                              height="100px"
                              style="border-radius: 15px"
                              class="pointer"
                              @click="updateVehicle(vehicle, index)"
                            >
                              <v-row class="ma-0">
                                <v-col cols="4" class="pa-0">
                                  <v-icon color="black" style="font-size: 100px"
                                    >mdi-car</v-icon
                                  >
                                </v-col>
                                <v-col cols="8" class="pa-2">
                                  <v-row
                                    class="ma-0"
                                    style="height: 50px; overflow-y: hidden"
                                  >
                                    <div
                                      class="mx-1"
                                      style="color: grey; font-size: 17px"
                                    >
                                      {{
                                        vehicle.vehicleYear +
                                        " " +
                                        vehicle.vehicleMake +
                                        " " +
                                        vehicle.vehicleModel
                                      }}
                                    </div>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="!newUser.vehicles || !newUser.vehicles[0]"
                          justify="center"
                          justify-md="start"
                          class="ma-0"
                        >
                          <h4 style="color: #4390c0" class="mx-2">
                            No company vehicles yet!
                          </h4>
                        </v-row>
                      </v-col>
                    </v-form>
                  </v-window-item>

                  <!-- Languages -->
                  <v-window-item :value="4" class="step-content">
                    <v-col class="px-4">
                      <v-row justify="center" ref="targetElement">
                        <h3 class="mt-6 mb-4">SELECT LANGUAGE</h3>
                      </v-row>
                      <v-row justify="center" class="ma-0 language-grid">
                        <v-col
                          v-for="lang in [
                            'English',
                            'Afrikaans',
                            'Zulu',
                            'Tswana',
                            'Xhosa',
                            'Sotho',
                            'isiNdebele',
                            'Sepedi',
                            'siSwati',
                            'Tshivenda',
                            'Xitsonga',
                          ]"
                          :key="lang"
                          cols="auto"
                          class="d-flex justify-center"
                        >
                          <v-card
                            @click="selectItem(lang)"
                            color="lightgrey"
                            :class="{
                              selected: languages.includes(lang),
                            }"
                            class="language-card pa-2"
                          >
                            <v-row
                              class="ma-0"
                              style="height: 100%"
                              justify="center"
                              align="center"
                            >
                              <h3 class="m-0">{{ lang }}</h3>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-window-item>

                  <!-- Fees -->
                  <v-window-item :value="5" class="step-content">
                    <v-form ref="businessFeeForm">
                      <v-row justify="center" class="ma-0" ref="targetElement">
                        <h3 class="mt-4">
                          CONSULTATION FEE(25% service charge will be added to
                          the rates)
                        </h3>
                      </v-row>
                      <v-col class="px-4">
                        <v-row justify="start" class="ma-0">
                          <h3 class="mt-4 my-3">
                            Callout Fee within a 5km radius(Per Hr)
                          </h3>
                        </v-row>
                        <v-row justify="center" class="ma-0">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Callout Fee (5km)"
                            v-model="newUser.calloutFee"
                            class="mt-0"
                            required
                            :rules="numberRules"
                          ></v-text-field>
                        </v-row>

                        <v-row justify="start" class="ma-0">
                          <h3 class="mt-4 my-3">
                            Callout Fee within a 10km radius(Per Hr)
                          </h3>
                        </v-row>
                        <v-row justify="center" class="ma-0">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Callout Fee (10km)"
                            v-model="newUser.calloutFee10km"
                            class="mt-0"
                            required
                            :rules="numberRules"
                          ></v-text-field>
                        </v-row>

                        <v-row justify="start" class="ma-0">
                          <h3 class="mt-4 my-3">
                            Callout Fee within a 15km radius(Per Hr)
                          </h3>
                        </v-row>
                        <v-row justify="center" class="ma-0">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Callout Fee (15km)"
                            v-model="newUser.calloutFee15km"
                            class="mt-0"
                            required
                            :rules="numberRules"
                          ></v-text-field>
                        </v-row>

                        <v-row justify="start" class="ma-0">
                          <h3 class="my-3">Online Consultation 30 Mins</h3>
                        </v-row>
                        <v-row justify="center" class="ma-0">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Online Consultation 30 Mins"
                            v-model="newUser.onlineFee30"
                            required
                            :rules="numberRules"
                          ></v-text-field>
                        </v-row>

                        <v-row justify="start" class="ma-0">
                          <h3 class="my-3">Online Consultation 45 Mins</h3>
                        </v-row>
                        <v-row justify="center" class="ma-0">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Online Consultation 45 Mins"
                            v-model="newUser.onlineFee45"
                            required
                            :rules="numberRules"
                          ></v-text-field>
                        </v-row>

                        <v-row justify="start" class="ma-0">
                          <h3 class="my-3">Online Consultation 1 Hr</h3>
                        </v-row>
                        <v-row justify="center" class="ma-0">
                          <v-text-field
                            dense
                            filled
                            rounded
                            label="Online Consultation 1 Hr"
                            v-model="newUser.onlineFee60"
                            required
                            :rules="numberRules"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-form>
                  </v-window-item>
                </template>
                <!-- ===================== END Business Registration Steps ===================== -->
              </v-window>
            </div>

            <!-- Navigation Buttons (sticky at bottom) -->
            <div class="card-footer">
              <v-row justify="center" class="ma-0 navigation-btns">
                <v-btn
                  class="nav-btn mx-4 mt-4"
                  color="black"
                  dark
                  rounded
                  @click="goBack"
                  >Back</v-btn
                >
                <v-btn
                  v-if="
                    maxWindows > 1 &&
                    step > 1 &&
                    step < maxWindows &&
                    accountType
                  "
                  class="nav-btn mx-4 mt-4"
                  outlined
                  rounded
                  @click="saveUser()"
                  >Next</v-btn
                >
                <v-btn
                  v-if="maxWindows > 1 && step == maxWindows"
                  class="nav-btn mx-4 mt-4"
                  outlined
                  rounded
                  @click="saveUser(true)"
                  >Finish</v-btn
                >
                <v-btn
                  v-if="step == 0"
                  class="nav-btn mx-4 mt-4"
                  outlined
                  rounded
                  @click="goNext"
                  >Continue</v-btn
                >
              </v-row>
              <v-row v-if="step === 1" class="ma-0 mt-4" justify="center">
                <v-btn
                  @click="registerUser()"
                  color="#e022d1"
                  dark
                  rounded
                  class="pink-btn"
                  >Register</v-btn
                >
              </v-row>
            </div>
          </div>
        </v-row>

        <!-- Loading Overlay -->
        <v-row justify="center">
          <v-overlay :value="loading">
            <v-progress-circular :size="100" color="#4390c0" indeterminate />
          </v-overlay>
        </v-row>

        <!-- Prompt Dialog -->
        <v-dialog v-model="promptDialog" max-width="480">
          <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
            <v-card-text class="text-center">
              <v-icon size="96" color="red" v-if="promptType === 'error'"
                >mdi-alert-circle</v-icon
              >
              <v-icon size="96" color="green" v-if="promptType === 'success'"
                >mdi-check-circle</v-icon
              >
              <div class="text-h5 my-6" v-if="promptType === 'error'">
                Error
              </div>
              <div class="text-h5 my-6" v-if="promptType === 'success'">
                Success
              </div>
              <div class="body-1 text-h6">{{ promptMessage }}</div>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                color="black"
                dark
                depressed
                large
                rounded
                @click="promptDialog = false"
                >CLOSE</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </div>

    <v-dialog width="500px" v-model="requestingClearance">
      <v-row justify="center">
        <v-card color="white" width="500px" class="pa-8">
          <v-row justify="center" class="ma-0">
            <img height="150px" src="../assets/images/logo.png" alt="Logo" />
          </v-row>
          <v-row justify="center" class="ma-0">
            <h2 class="blue-color text-center">
              Request Criminal Check From Lotus
            </h2>
          </v-row>
          <v-row justify="center" class="ma-0 mt-4">
            <h3 class="black-color text-center">
              Lotus can perform a criminal check on your behalf at a cost. Are
              you sure you want to request this?
            </h3>
          </v-row>
          <v-row justify="center" class="ma-0 mt-4">
            <v-btn
              @click="uploadRequest()"
              color="#4390c0"
              dark
              rounded
              width="240px"
              class="mt-4"
              >Request</v-btn
            >
          </v-row>
          <v-row justify="center" class="ma-0">
            <v-btn
              @click="requestingClearance = false"
              color="#e022d1"
              dark
              rounded
              width="240px"
              class="mt-4"
              >Cancel</v-btn
            >
          </v-row>
        </v-card>
      </v-row>
    </v-dialog>
    <v-dialog v-model="deleteDocDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="green">mdi-check-circle</v-icon>
          <div class="body-1 text-h6">
            Are you sure you want to delete this certificate?
          </div>
        </v-card-text>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="deleteDocDialog = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="deleteDoc()"
            >DELETE</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resetDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="green">mdi-check-circle</v-icon>
          <div class="body-1 text-h6">
            Are you sure you want to register a new account?
          </div>
        </v-card-text>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="resetDialog = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="resetRegistration()"
            >CONFIRM</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog width="500px" v-model="addingVehicle">
      <v-row justify="center">
        <v-card color="white" width="500px" class="pa-8">
          <v-row class="ma-0" justify="center">
            <h2 class="mb-4">Add Vehicle</h2>
          </v-row>
          <v-form ref="vehicleForm">
            <v-row class="ma-0">
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleMake"
                  class="textfield mx-2"
                  label="Vehicle Make"
                  dense
                  filled
                  outlined
                  required
                  :rules="nullRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleModel"
                  class="textfield mx-2"
                  label="Vehicle Model"
                  dense
                  filled
                  outlined
                  required
                  :rules="nullRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleYear"
                  class="textfield mx-2"
                  label="Year"
                  dense
                  filled
                  outlined
                  required
                  :rules="numberRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleColour"
                  class="textfield mx-2"
                  label="Colour"
                  dense
                  filled
                  outlined
                  required
                  :rules="letterRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-text-field
                  v-model="vehicleReg"
                  class="textfield mx-2"
                  label="Registration"
                  dense
                  filled
                  outlined
                  required
                  :rules="nullRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-row justify="center" class="my-2">
            <v-btn
              color="black"
              dark
              class="mx-2"
              style="border-radius: 24px"
              @click="addingVehicle = false"
              >CANCEL</v-btn
            >
            <v-btn
              v-if="updatingVehicle"
              color="red"
              dark
              class="mx-2"
              style="border-radius: 24px"
              @click="deleteVehicle(vehicle)"
              >DELETE</v-btn
            >
            <v-btn
              color="blue"
              dark
              class="mx-2"
              style="border-radius: 24px"
              @click="handleVehicle()"
              >CONFIRM</v-btn
            >
          </v-row>
        </v-card>
      </v-row>
    </v-dialog>
    <v-dialog width="400px" v-model="addingSpeciality">
      <v-card width="400px" class="pa-8">
        <v-row class="ma-0" justify="center">
          <h3>Add Speciality</h3>
        </v-row>
        <v-row class="ma-0" justify="center">
          <v-text-field
            v-model="speciality"
            class="textfield mx-2"
            label="Speciality"
            dense
            filled
            outlined
            required
            :rules="nullRules"
          ></v-text-field>
        </v-row>
        <v-row class="ma-0" justify="center">
          <v-btn
            color="black"
            dark
            class="mx-2"
            style="border-radius: 24px"
            @click="addingSpeciality = false"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            class="mx-2"
            style="border-radius: 24px"
            @click="addSpeciality()"
            >Add</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  addDoc,
  Timestamp,
  setDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
const storage = getStorage(firebaseApp);

// Import the separate component for mobile rendering
import { register } from "register-service-worker";
import ZAAddressAutocomplete from "../components/ZAAddressAutocomplete.vue";

import generateUniqueId from "generate-unique-id";

import { Browser } from "@capacitor/browser";

import Vue from "vue";

export default {
  components: {
    ZAAddressAutocomplete,
  },
  data() {
    return {
      /* ===================== Validation Rules ===================== */
      idNumberRules: [
        (v) => !!v || "ID number is required",
        (v) => /^\d{13}$/.test(v) || "ID number must be exactly 13 digits",
      ],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 6) || "Password must be at least 6 characters",
        (v) =>
          /(?=.*[A-Z])/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /(?=.*[a-z])/.test(v) ||
          "Password must contain at least one lowercase letter",
        (v) =>
          /(?=.*[0-9])/.test(v) || "Password must contain at least one number",
        (v) =>
          /(?=.*[!@#+*\$%\^&])/.test(v) ||
          "Password must contain at least one special character",
      ],
      nullRules: [(v) => !!v || "Field is required"],
      contactRules: [
        (v) =>
          !v || /^\d{10}$/.test(v) || "Contact must be a valid 10-digit number",
      ],
      numberRules: [
        (v) => !!v || "Field is required",
        (v) => /^\d+$/.test(v) || "Field must be numbers only",
      ],
      numberRulesNR: [
        (v) => !v || /^\d+$/.test(v) || "Field must be numbers only",
      ],
      letterRules: [
        (v) => !!v || "Field is required",
        (v) =>
          /^[A-Za-z\s]+$/.test(v) ||
          "Field must only contain letters and spaces",
      ],
      letterRulesNR: [
        (v) =>
          !v ||
          /^[A-Za-z\s]+$/.test(v) ||
          "Field must only contain letters and spaces",
      ],
      /* ===================== Account Flow ===================== */
      accountType: "Individual",
      step: 0,
      clientPreference: null,
      languages: [],
      gender: "Male",
      professions: [],
      maxWindows: 1,
      /* ===================== Common Fields ===================== */
      name: null,
      surname: null,
      dateOfBirth: null,
      email: null,
      idNumber: null,
      password: null,
      city: null,
      province: null,
      postalCode: null,
      cellNo: null,
      profession: null,
      certificates: [],
      vehicleMake: null,
      vehicleModel: null,
      vehicleYear: null,
      vehicleColour: null,
      vehicleReg: null,
      calloutFee: null,
      onlineFee30: null,
      onlineFee45: null,
      onlineFee60: null,
      instagramUrl: null,
      facebookUrl: null,
      linkedInUrl: null,
      businessID: null,
      address: null,
      loading: false,
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      file1: null,
      file2: null,
      companyName: null,
      practiceNumber: null,
      confirmPassword: null,
      accountTypes: ["Cheque", "Savings"],
      bankName: null,
      accountNumber: null,
      branchCode: null,
      bankAccountType: null,
      requestingClearance: false,
      companies: [],
      selectedCompany: null,
      show: null,
      medicalLicenseNumber: null,
      medicalAids: [
        "Discovery Health",
        "Bonitas",
        "Bestmed",
        "Sizwe Hosmed",
        "Medihelp",
        "Momentum",
        "Genesis",
        "Fedhealth",
        "Medshield",
        "Profmed",
      ],
      medicalAid: null,
      createdID: null,
      newUser: {},
      firestoreID: null,
      userExists: false,
      deleteIndex: 0,
      deleteDocDialog: false,
      selectedSection: null,
      certificateName: null,
      certificateExpiry: null,
      requiredDocs: [
        { title: "Identitification Documents", key: "identityDocs" },
        { title: "Proof of Physical Address Documents", key: "addressDocs" },
        { title: "Proof of Banking Documents", key: "bankingDocs" },
        { title: "Qualification Documents", key: "qualificationDocs" },
        {
          title:
            "Health Professions Council of SA Documents(or Practitioners Country)",
          key: "healthCouncilDocs",
        },
        { title: "Drivers License Documents", key: "driversLicenseDocs" },
        { title: "Vehicle Registration Documents", key: "vehicleRegDocs" },
        {
          title: "Vehicle License Disk Documents",
          key: "vehicleLicenseDiskDocs",
        },
        {
          title: "Proof of Business Address Documents",
          key: "businessAddressDocs",
        },
        {
          title: "Work Permit Documents(Asylum & Passport)",
          key: "workPermitDocs",
        },
        { title: "Criminal Check Documents", key: "criminalCheckDocs" },
      ],
      requiredCompanyDocs: [
        {
          title: "Proof of Business Physical Address Documents",
          key: "addressDocs",
        },
        { title: "Proof of Business Banking Documents", key: "bankingDocs" },
        { title: "Company Registration Documents", key: "companyRegDocs" },
        { title: "VAT Registration Documents", key: "vatRegDocs" },
      ],
      resetDialog: false,
      openPanelIndex: null,
      hearAboutUsOptions: [
        "Facebook",
        "LinkedIn",
        "YouTube",
        "Our Sales Team",
        "Radio",
        "Website",
      ],
      // merchantId: '10040492',
      // merchantKey: 'ny33hkarlf0k9',
      merchantId: "32341077",
      merchantKey: "rn67nh9zbn8z2",
      amount: 100,
      paymentCode: null,
      code: null,
      preferences: ["men", "women", "children", "pets"],
      countries: [
        { name: "South Africa", code: "ZA" },
        { name: "Afghanistan", code: "AF" },
        { name: "Albania", code: "AL" },
        { name: "Algeria", code: "DZ" },
        { name: "Andorra", code: "AD" },
        { name: "Angola", code: "AO" },
        { name: "Antigua and Barbuda", code: "AG" },
        { name: "Argentina", code: "AR" },
        { name: "Armenia", code: "AM" },
        { name: "Australia", code: "AU" },
        { name: "Austria", code: "AT" },
        { name: "Azerbaijan", code: "AZ" },
        { name: "Bahamas", code: "BS" },
        { name: "Bahrain", code: "BH" },
        { name: "Bangladesh", code: "BD" },
        { name: "Barbados", code: "BB" },
        { name: "Belarus", code: "BY" },
        { name: "Belgium", code: "BE" },
        { name: "Belize", code: "BZ" },
        { name: "Benin", code: "BJ" },
        { name: "Bhutan", code: "BT" },
        { name: "Bolivia", code: "BO" },
        { name: "Bosnia and Herzegovina", code: "BA" },
        { name: "Botswana", code: "BW" },
        { name: "Brazil", code: "BR" },
        { name: "Brunei", code: "BN" },
        { name: "Bulgaria", code: "BG" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Burundi", code: "BI" },
        { name: "Cabo Verde", code: "CV" },
        { name: "Cambodia", code: "KH" },
        { name: "Cameroon", code: "CM" },
        { name: "Canada", code: "CA" },
        { name: "Central African Republic", code: "CF" },
        { name: "Chad", code: "TD" },
        { name: "Chile", code: "CL" },
        { name: "China", code: "CN" },
        { name: "Colombia", code: "CO" },
        { name: "Comoros", code: "KM" },
        { name: "Congo (Congo-Brazzaville)", code: "CG" },
        { name: "Costa Rica", code: "CR" },
        { name: "Croatia", code: "HR" },
        { name: "Cuba", code: "CU" },
        { name: "Cyprus", code: "CY" },
        { name: "Czechia (Czech Republic)", code: "CZ" },
        { name: "Democratic Republic of the Congo", code: "CD" },
        { name: "Denmark", code: "DK" },
        { name: "Djibouti", code: "DJ" },
        { name: "Dominica", code: "DM" },
        { name: "Dominican Republic", code: "DO" },
        { name: "Ecuador", code: "EC" },
        { name: "Egypt", code: "EG" },
        { name: "El Salvador", code: "SV" },
        { name: "Equatorial Guinea", code: "GQ" },
        { name: "Eritrea", code: "ER" },
        { name: "Estonia", code: "EE" },
        { name: "Eswatini (fmr. Swaziland)", code: "SZ" },
        { name: "Ethiopia", code: "ET" },
        { name: "Fiji", code: "FJ" },
        { name: "Finland", code: "FI" },
        { name: "France", code: "FR" },
        { name: "Gabon", code: "GA" },
        { name: "Gambia", code: "GM" },
        { name: "Georgia", code: "GE" },
        { name: "Germany", code: "DE" },
        { name: "Ghana", code: "GH" },
        { name: "Greece", code: "GR" },
        { name: "Grenada", code: "GD" },
        { name: "Guatemala", code: "GT" },
        { name: "Guinea", code: "GN" },
        { name: "Guinea-Bissau", code: "GW" },
        { name: "Guyana", code: "GY" },
        { name: "Haiti", code: "HT" },
        { name: "Honduras", code: "HN" },
        { name: "Hungary", code: "HU" },
        { name: "Iceland", code: "IS" },
        { name: "India", code: "IN" },
        { name: "Indonesia", code: "ID" },
        { name: "Iran", code: "IR" },
        { name: "Iraq", code: "IQ" },
        { name: "Ireland", code: "IE" },
        { name: "Israel", code: "IL" },
        { name: "Italy", code: "IT" },
        { name: "Jamaica", code: "JM" },
        { name: "Japan", code: "JP" },
        { name: "Jordan", code: "JO" },
        { name: "Kazakhstan", code: "KZ" },
        { name: "Kenya", code: "KE" },
        { name: "Kiribati", code: "KI" },
        { name: "Kuwait", code: "KW" },
        { name: "Kyrgyzstan", code: "KG" },
        { name: "Laos", code: "LA" },
        { name: "Latvia", code: "LV" },
        { name: "Lebanon", code: "LB" },
        { name: "Lesotho", code: "LS" },
        { name: "Liberia", code: "LR" },
        { name: "Libya", code: "LY" },
        { name: "Liechtenstein", code: "LI" },
        { name: "Lithuania", code: "LT" },
        { name: "Luxembourg", code: "LU" },
        { name: "Madagascar", code: "MG" },
        { name: "Malawi", code: "MW" },
        { name: "Malaysia", code: "MY" },
        { name: "Maldives", code: "MV" },
        { name: "Mali", code: "ML" },
        { name: "Malta", code: "MT" },
        { name: "Marshall Islands", code: "MH" },
        { name: "Mauritania", code: "MR" },
        { name: "Mauritius", code: "MU" },
        { name: "Mexico", code: "MX" },
        { name: "Micronesia", code: "FM" },
        { name: "Moldova", code: "MD" },
        { name: "Monaco", code: "MC" },
        { name: "Mongolia", code: "MN" },
        { name: "Montenegro", code: "ME" },
        { name: "Morocco", code: "MA" },
        { name: "Mozambique", code: "MZ" },
        { name: "Myanmar (Burma)", code: "MM" },
        { name: "Namibia", code: "NA" },
        { name: "Nauru", code: "NR" },
        { name: "Nepal", code: "NP" },
        { name: "Netherlands", code: "NL" },
        { name: "New Zealand", code: "NZ" },
        { name: "Nicaragua", code: "NI" },
        { name: "Niger", code: "NE" },
        { name: "Nigeria", code: "NG" },
        { name: "North Korea", code: "KP" },
        { name: "North Macedonia", code: "MK" },
        { name: "Norway", code: "NO" },
        { name: "Oman", code: "OM" },
        { name: "Pakistan", code: "PK" },
        { name: "Palau", code: "PW" },
        { name: "Palestine", code: "PS" },
        { name: "Panama", code: "PA" },
        { name: "Papua New Guinea", code: "PG" },
        { name: "Paraguay", code: "PY" },
        { name: "Peru", code: "PE" },
        { name: "Philippines", code: "PH" },
        { name: "Poland", code: "PL" },
        { name: "Portugal", code: "PT" },
        { name: "Qatar", code: "QA" },
        { name: "Romania", code: "RO" },
        { name: "Russia", code: "RU" },
        { name: "Rwanda", code: "RW" },
        { name: "Saint Kitts and Nevis", code: "KN" },
        { name: "Saint Lucia", code: "LC" },
        { name: "Saint Vincent and the Grenadines", code: "VC" },
        { name: "Samoa", code: "WS" },
        { name: "San Marino", code: "SM" },
        { name: "Sao Tome and Principe", code: "ST" },
        { name: "Saudi Arabia", code: "SA" },
        { name: "Senegal", code: "SN" },
        { name: "Serbia", code: "RS" },
        { name: "Seychelles", code: "SC" },
        { name: "Sierra Leone", code: "SL" },
        { name: "Singapore", code: "SG" },
        { name: "Slovakia", code: "SK" },
        { name: "Slovenia", code: "SI" },
        { name: "Solomon Islands", code: "SB" },
        { name: "Somalia", code: "SO" },
        { name: "South Korea", code: "KR" },
        { name: "South Sudan", code: "SS" },
        { name: "Spain", code: "ES" },
        { name: "Sri Lanka", code: "LK" },
        { name: "Sudan", code: "SD" },
        { name: "Suriname", code: "SR" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Syria", code: "SY" },
        { name: "Taiwan", code: "TW" },
        { name: "Tajikistan", code: "TJ" },
        { name: "Tanzania", code: "TZ" },
        { name: "Thailand", code: "TH" },
        { name: "Timor-Leste", code: "TL" },
        { name: "Togo", code: "TG" },
        { name: "Tonga", code: "TO" },
        { name: "Trinidad and Tobago", code: "TT" },
        { name: "Tunisia", code: "TN" },
        { name: "Turkey", code: "TR" },
        { name: "Turkmenistan", code: "TM" },
        { name: "Tuvalu", code: "TV" },
        { name: "Uganda", code: "UG" },
        { name: "Ukraine", code: "UA" },
        { name: "United Arab Emirates", code: "AE" },
        { name: "United Kingdom", code: "GB" },
        { name: "United States of America", code: "US" },
        { name: "Uruguay", code: "UY" },
        { name: "Uzbekistan", code: "UZ" },
        { name: "Vanuatu", code: "VU" },
        { name: "Vatican City", code: "VA" },
        { name: "Venezuela", code: "VE" },
        { name: "Vietnam", code: "VN" },
        { name: "Yemen", code: "YE" },
        { name: "Zambia", code: "ZM" },
        { name: "Zimbabwe", code: "ZW" },
      ],
      showTnCDialog: false,
      tncAccepted: false,
      addingVehicle: false,
      vehicleMake: "",
      vehicleModel: "",
      vehicleYear: "",
      vehicleColour: "",
      vehicleReg: "",
      updatingVehicle: false,
      updateIndex: 0,
      min: 0,
      max: 100,
      specialities: [],
      addingSpeciality: false,
      speciality: null,
      requestID: null,
      titleOptions: [
        "Dr",
        "Prof",
        "Assoc. Prof",
        "Emeritus Prof",
        "Mr",
        "Ms",
        "Mrs",
        "Miss",
        "Sr",
        "RN",
        "EN",
        "CNP",
        "Pharm/RPh",
      ],
      degreeOptions: [
        "MBChB",
        "MBBS",
        "MD",
        "PhD",
        "BDS/DDS",
        "MSc/MPhil",
        "FC",
        "MMed",
      ],
    };
  },
  // https://lotus-life-dashboard.web.app/register
  methods: {
    async getProfessions() {
      try {
        let q = query(collection(db, "professions"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.professions = [];

        querySnapshot.docs.forEach((doc) => {
          let tempProfession = doc.data();
          tempProfession.id = doc.id;

          this.professions.push(tempProfession);
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    openFilePicker() {
      // Programmatically trigger the hidden input
      this.$refs.fileInput.click();
    },
    sanitizeAddressForSave(addr) {
      if (!addr) return null;
      if (typeof addr === "string") {
        const placeName = addr.trim();
        return placeName ? { placeName, coordinates: {} } : null;
      }
      const lat = typeof addr.lat === "number" ? addr.lat : undefined;
      const lon = typeof addr.lon === "number" ? addr.lon : undefined;
      const placeName =
        addr.placeName ||
        addr.addressText ||
        addr.display ||
        addr.place_name ||
        addr.title ||
        addr.text ||
        "";
      const minimal = { placeName: placeName || "", coordinates: {} };
      if (lat !== undefined) minimal.coordinates.latitude = lat;
      if (lon !== undefined) minimal.coordinates.longitude = lon;
      return minimal;
    },
    buildSanitizedPayload() {
      const payload = { ...this.newUser };
      if (payload.address !== undefined) {
        payload.address = this.sanitizeAddressForSave(payload.address);
      }
      if (payload.businessAddress !== undefined) {
        payload.businessAddress = this.sanitizeAddressForSave(
          payload.businessAddress,
        );
      }
      // remove any standalone lat/lon fields; we store inside the address object only
      delete payload.latitude;
      delete payload.longitude;
      delete payload.businessLatitude;
      delete payload.businessLongitude;
      if (payload.profilePhoto && payload.profilePhoto._raw) {
        delete payload.profilePhoto._raw;
      }
      return payload;
    },
    onAddressSelected() {},
    addVehicle() {
      this.vehicleMake = "";
      this.vehicleModel = "";
      this.vehicleYear = "";
      this.vehicleColour = "";
      this.vehicleReg = "";
      this.updatingVehicle = false;
      this.addingVehicle = true;
    },
    updateVehicle(vehicle, index) {
      this.updateIndex = index;
      this.vehicleMake = vehicle.vehicleMake;
      this.vehicleModel = vehicle.vehicleModel;
      this.vehicleYear = vehicle.vehicleYear;
      this.vehicleColour = vehicle.vehicleColour;
      this.vehicleReg = vehicle.vehicleReg;
      this.updatingVehicle = true;
      this.addingVehicle = true;
    },
    deleteVehicle(vehicle) {
      this.newUser.vehicles.splice(this.newUser.vehicles.indexOf(vehicle), 1);
    },
    handleVehicle(index) {
      let valid = this.$refs.vehicleForm.validate();

      if (!valid) {
        this.promptMessage = "Please fill out all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.addingVehicle = false;

      if (this.updatingVehicle) {
        let newVehicle = {
          vehicleMake: this.vehicleMake,
          vehicleModel: this.vehicleModel,
          vehicleYear: this.vehicleYear,
          vehicleColour: this.vehicleColour,
          vehicleReg: this.vehicleReg,
        };

        this.newUser.vehicles[this.updateIndex] = newVehicle;
      } else {
        if (!this.newUser.vehicles) {
          this.newUser.vehicles = [];
        }

        let newVehicle = {
          vehicleMake: this.vehicleMake,
          vehicleModel: this.vehicleModel,
          vehicleYear: this.vehicleYear,
          vehicleColour: this.vehicleColour,
          vehicleReg: this.vehicleReg,
        };

        this.newUser.vehicles.push(newVehicle);
      }
    },
    setGender(gender) {
      this.gender = gender;

      if (gender == "Male") {
        this.preferences = ["men", "women", "children", "pets"];
      } else if (gender == "Female") {
        this.preferences = ["men", "women", "children", "pets"];
      }
    },
    generate10DigitCode() {
      let code = "";
      for (let i = 0; i < 10; i++) {
        code += Math.floor(Math.random() * 10);
      }
      return code;
    },
    togglePanel(index) {
      if (this.openPanelIndex) {
        if (this.openPanelIndex == index) {
          this.openPanelIndex = null;
        } else {
          this.openPanelIndex = index;
          this.certificateName = null;
          this.certificateExpiry = null;
        }
      } else {
        this.openPanelIndex = index;
      }
    },
    async onFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        this.file = file;

        const newRef = ref(
          storage,
          "Doctors/" +
            this.newUser.id +
            "/Documents/" +
            "ProfilePhoto" +
            ".png",
        );

        try {
          this.loading = true;
          const snapshot = await uploadBytes(newRef, file);
          const url = await getDownloadURL(newRef);

          if (!this.newUser.profilePhoto) {
            this.newUser.profilePhoto = {};
          }

          this.newUser.profilePhoto.url = url;
          this.newUser.profilePhoto.ref = newRef.fullPath;

          this.loading = false;

          const normalized = this.buildSanitizedPayload();
          this.loading = true;
          let res2 = await setDoc(
            doc(db, "doctors", this.newUser.id),
            normalized,
          );
          this.loading = false;

          localStorage.setItem("regUser", JSON.stringify(normalized));
        } catch (error) {
          this.loading = false;
          console.log("error: ", false);
          this.promptMessage =
            "An error occured while uploading the profile photo, please try again!";
          this.promptType = "error";
          this.promptDialog = true;
        }
      } else {
        this.promptMessage = "Please select an image!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    resetRegistration() {
      this.newUser = {};
      this.accountType = "Individual";
      this.maxWindows = 1;
      this.step = 0;
      this.resetDialog = false;
    },
    setRequestClearance() {
      this.requestingClearance = false;
      this.newUser.requestClearance = true;

      this.promptMessage =
        "Successfully added a request for police clearance from Lotus!";
      this.promptType = "success";
      this.promptDialog = true;

      setTimeout(() => {
        this.promptDialog = false;
      }, 3000);
    },
    goNext() {
      if (this.step < this.maxWindows) {
        this.step++;
      }
      this.scrollToElement();
    },
    scrollToElement() {
      const container = this.$refs.scrollWindow;
      const target = this.$refs.targetElement;

      if (container && target) {
        // Calculate the position of the target relative to the container
        const offsetTop = target.offsetTop - container.offsetTop;
        console.log("Scrolling to top!");
        container.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    },
    goBack() {
      if (this.step > 0) {
        this.step--;
      } else {
        this.$router.push("/");
      }
      this.scrollToElement();
    },
    selectItem(language) {
      if (this.languages.includes(language)) {
        this.languages.splice(this.languages.indexOf(language), 1);
      } else {
        this.languages.push(language);
      }
    },
    async createUserAuth() {
      Vue.delete(this.newUser.confirmEmail);

      let body = JSON.stringify({
        data: {
          email: this.newUser.email,
          password: this.newUser.password,
        },
      });
      this.loading = true;
      try {
        const authRes = await fetch(
          "https://createauthuser-4woel4f54a-uc.a.run.app",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: body,
          },
        );
        this.loading = false;
        if (authRes.ok) {
          const responseBody = await authRes.json();
          if (responseBody.result.success) {
            return { success: responseBody.result.success };
          } else {
            return { error: responseBody.result.error };
          }
        }
      } catch (error) {
        this.loading = false;
        return { error };
      }
    },
    handleSubmit() {
      if (step <= 1) {
        this.registerUser();
      } else {
        this.saveUser();
      }
    },
    async registerUser() {
      if (!this.tncAccepted) {
        this.promptMessage =
          "You must accept the Terms & Conditions to proceed!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      let valid = this.$refs.regForm.validate();

      if (!valid) {
        this.promptMessage = "Please enter all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      // if (this.accountType === "Individual" && !this.newUser.availability) {
      //   this.promptMessage = "Please select available services!";
      //   this.promptType = "error";
      //   this.promptDialog = true;
      //   return;
      // }

      if (this.newUser.password != this.newUser.confirmPassword) {
        this.promptMessage = "Passwords need to match!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (this.newUser.CellNo == this.newUser.alternativeNumber) {
        this.promptMessage =
          "Please provide a different alternative number to your cell number!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.newUser.email = this.newUser.email.toLowerCase();

      if (this.newUser.email != this.newUser.confirmEmail) {
        this.promptMessage = "Email addresses need to match!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (this.accountType === "Individual") {
        if (!this.gender) {
          this.promptMessage = "Please select a gender!";
          this.promptType = "error";
          this.promptDialog = true;
        }

        let res = await this.createUserAuth();

        if (res.success) {
          this.createdID = res.success;
        } else {
          this.promptMessage = res.error;
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        let newDoctor = {
          ...this.newUser,
          email: this.newUser.email.toLowerCase(),
          accountType: this.accountType,
          authID: this.createdID,
          gender: this.gender,
          status: "pending",
          setupComplete: false,
          userType: "Doctor",
          tncAccepted: true, // Store T&Cs acceptance
          accountCreationDate: new Date(),
        };

        // coordinates will be embedded within the address objects during normalization

        if (this.newUser.landline) {
          newDoctor.landline = this.newUser.landline;
        }

        if (this.newUser.bio) {
          newDoctor.bio = this.newUser.bio;
        }

        if (this.newUser.selectedCompany) {
          newDoctor.businessID = this.newUser.selectedCompany;
        }

        // Normalize addresses into { text, latitude, longitude, ... }
        if (newDoctor.address.key) {
          newDoctor.address = this.sanitizeAddressForSave(newDoctor.address);
        }

        if (newDoctor.businessAddress.key) {
          newDoctor.businessAddress = this.sanitizeAddressForSave(
            newDoctor.businessAddress,
          );
        }

        newDoctor.lotusMemNumber = generateUniqueId({
          length: 8, // number of characters
          useLetters: true, // include letters
          useNumbers: true, // include numbers
        });

        newDoctor.subscription = {
          activationDate: Timestamp.fromDate(new Date()),
          consultsExpiry: Timestamp.fromDate(new Date(2200, 11, 31)),
          consultsLeft: "3",
          packageName: "Free",
          freeAdsLeft: 0,
          adsDiscount: 0,
          articlesDiscount: 0,
        };

        newDoctor.clientAgePreference = [0, 100];

        this.loading = true;
        await addDoc(collection(db, "doctors"), newDoctor);
        this.loading = false;

        this.promptMessage =
          "Account created successfully! Please log in to complete your profile.";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.promptDialog = false;
          this.$router.push("/");
        }, 2500);
      } else if (this.accountType === "Business") {
        let res = await this.createUserAuth();

        if (res.success) {
          this.createdID = res.success;
        } else {
          this.promptMessage = res.error;
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        let newBusiness = {
          ...this.newUser,
          email: this.newUser.email.toLowerCase(),
          authID: this.createdID,
          userType: "Company",
          tncAccepted: true, // Store T&Cs acceptance
          accountCreationDate: new Date(),
          status: "pending",
          setupComplete: false,
        };

        // coordinates will be embedded within the address objects during normalization

        if (this.newUser.hearAboutUs) {
          newBusiness.hearAboutUs = this.newUser.hearAboutUs;
        }

        if (this.newUser.landline) {
          newBusiness.landline = this.newUser.landline;
        }

        try {
          newBusiness.lotusMemNumber = generateUniqueId({
            length: 8, // number of characters
            useLetters: true, // include letters
            useNumbers: true, // include numbers
          });

          // Normalize addresses into { text, latitude, longitude, ... }
          if (newBusiness.address.key) {
            newBusiness.address = this.sanitizeAddressForSave(
              newBusiness.address,
            );
          }

          this.loading = true;
          await addDoc(collection(db, "businesses"), newBusiness);
          this.loading = false;

          this.promptMessage =
            "Account created successfully! Please log in to complete your profile.";
          this.promptType = "success";
          this.promptDialog = true;

          setTimeout(() => {
            this.promptDialog = false;
            this.$router.push("/");
          }, 2500);
        } catch (error) {
          console.log("Error: ", error);
          this.loading = false;
          this.promptMessage =
            "An error occurred while registering, please try again!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }
      }
    },
    async saveUser(finish, skipNext) {
      if (this.step == 1 && !this.tncAccepted) {
        this.promptMessage =
          "You must accept the Terms & Conditions to proceed!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      /* Validate required fields based on merged steps */

      if (this.step == 1) {
        let valid = this.$refs.regForm.validate();

        if (!valid) {
          console.log("Valid: ", valid);
          this.promptMessage = "Please enter all required fields!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        // if (this.accountType === "Individual" && !this.newUser.availability) {
        //   this.promptMessage = "Please select available services!";
        //   this.promptType = "error";
        //   this.promptDialog = true;
        //   return;
        // }
      }

      if (this.accountType === "Individual") {
        let valid;

        if (this.step == 3) {
          valid = this.$refs.medicalForm.validate();

          if (
            !this.newUser.profession ||
            !this.newUser.profession[0] ||
            !this.newUser.clientPreference
          ) {
            this.promptMessage = "Please enter all required fields!";
            this.promptType = "error";
            this.promptDialog = true;
            return;
          }
        } else if (this.step == 4) {
          valid = this.$refs.vehicleForm.validate();
        } else if (this.step == 7) {
          valid = this.$refs.feeForm.validate();
        } else if (this.step == 8) {
          valid = this.$refs.bankingForm.validate();
        } else {
          valid = true;
        }

        if (!valid) {
          console.log("Valid: ", valid);
          this.promptMessage = "Please enter all required fields!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        if (this.step == 5 && !this.languages.length) {
          this.promptMessage = "Please select at least 1 language!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        try {
          if (this.languages && this.languages.length) {
            this.newUser.languages = this.languages;
          }

          this.newUser.gender = this.gender;

          if (this.newUser.address.key) {
            this.newUser.address = this.sanitizeAddressForSave(
              this.newUser.address,
            );
          }

          if (this.newUser.businessAddress.key) {
            this.newUser.businessAddress = this.sanitizeAddressForSave(
              this.newUser.businessAddress,
            );
          }

          console.log(this.newUser);
          // return;
          this.loading = true;
          let res2 = await setDoc(
            doc(db, "doctors", this.newUser.id),
            this.newUser,
          );
          this.loading = false;

          localStorage.setItem("regUser", JSON.stringify(this.newUser));

          if (!skipNext) {
            this.goNext();
          }

          if (finish) {
            localStorage.removeItem("regUser");

            this.promptMessage = "Successfully Registered!";
            this.promptType = "success";
            this.promptDialog = true;

            setTimeout(() => {
              this.promptDialog = false;
              this.$router.push("/");
            }, 3000);
          }
        } catch (error) {
          console.log("Error: ", error);
          this.loading = false;
          this.promptMessage =
            "An error occurred while registering the user, please try again!";
          this.promptType = "error";
          this.promptDialog = true;
        }
      } else {
        if (this.step == 4 && !this.languages.length) {
          this.promptMessage = "Please select at least 1 language!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        if (this.step == 3 && !this.newUser.medicalAid) {
          this.promptMessage = "Please select at least 1 medical aid!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }

        if (this.languages && this.languages.length) {
          this.newUser.languages = this.languages;
        }

        if (this.newUser.address.key) {
          this.newUser.address = this.sanitizeAddressForSave(
            this.newUser.address,
          );
        }

        try {
          this.loading = true;
          let res2 = await setDoc(
            doc(db, "businesses", this.newUser.id),
            this.newUser,
          );
          this.loading = false;

          localStorage.setItem("regUser", JSON.stringify(this.newUser));

          if (!skipNext) {
            this.goNext();
          }

          if (finish) {
            localStorage.removeItem("regUser");

            this.promptMessage = "Successfully Registered!";
            this.promptType = "success";
            this.promptDialog = true;

            setTimeout(() => {
              this.promptDialog = false;
              this.$router.push("/");
            }, 3000);
          }
        } catch (error) {
          console.log("Error: ", error);
          this.loading = false;
          this.promptMessage =
            "An error occurred while registering the user, please try again!";
          this.promptType = "error";
          this.promptDialog = true;
        }
      }
    },
    async getCompanies() {
      try {
        let q = query(collection(db, "businesses"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.companies = [];

        querySnapshot.docs.forEach((doc) => {
          let tempCompany = doc.data();
          tempCompany.id = doc.id;

          this.companies.push(tempCompany);
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    async redirectToPayFast() {
      // Use correct base URL
      const baseUrl = "https://lotus-life-doctor.web.app";

      const params = new URLSearchParams({
        merchant_id: this.merchantId,
        merchant_key: this.merchantKey,
        amount: this.amount,
        item_name: `Criminal Check Fee`,
        return_url: `${baseUrl}/success?paymentCode=${this.newUser.id}&success=${this.amount}`,
        cancel_url: `${baseUrl}/profile`,
        notify_url: "https://uploadrequest-4woel4f54a-uc.a.run.app",
        custom_str1: this.requestID,
        custom_str2: this.newUser.id,
      });

      const redirectUrl = `${baseUrl}/uploadRequestPayfast.html?${params.toString()}`;
      await Browser.open({ url: redirectUrl });
    },
    async uploadRequest() {
      this.requestingClearance = false;

      try {
        let newRequest = {
          name: this.newUser.name,
          surname: this.newUser.surname,
          dateOfBirth: this.newUser.dateOfBirth,
          email: this.newUser.email,
          idNumber: this.newUser.idNumber,
          CellNo: this.newUser.CellNo,
          address: this.newUser.address,
          status: "pending",
        };

        // localStorage.removeItem("regUser");

        this.loading = true;
        let requestRef = await addDoc(
          collection(db, "clearanceRequestsToAdd"),
          newRequest,
        );
        this.loading = false;

        this.requestID = requestRef.id;

        this.redirectToPayFast();
      } catch (error) {
        this.loading = false;
        this.promptMessage = "Something went wrong, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async addDoc(doc, section) {
      if (!doc) {
        return;
      }

      console.log("Certificate: ", doc);
      if (!this.certificateExpiry) {
        this.$refs.fileInput.reset();
        this.promptMessage = "Please enter an expiry date!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (!this.certificateName) {
        this.$refs.fileInput.reset();
        this.promptMessage = "Please enter a name for the certificate!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (doc.type != "application/pdf") {
        this.$refs.fileInput.reset();
        this.promptMessage = "Ceritifcate has to be a pdf file!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      let newCertificate = {
        document: doc,
        name: this.certificateName,
        expiryDate: this.certificateExpiry,
        section: section,
      };

      let res = await this.uploadDoc(newCertificate, section, true);

      this.promptMessage = "Document added successfully!";
      this.promptType = "success";
      this.promptDialog = true;

      setTimeout(() => {
        this.promptDialog = false;
      }, 3000);

      this.certificateName = null;
      this.certificateExpiry = null;
      this.file1 = null;
    },
    async uploadDoc(doc, section, addToUser) {
      const newRef = ref(
        storage,
        "Doctors/" +
          this.newUser.id +
          "/Documents/" +
          section.title +
          "/" +
          doc.name +
          ".pdf",
      );

      this.loading = true;

      try {
        const snapshot = await uploadBytes(newRef, doc.document);
        const url = await getDownloadURL(newRef);

        doc.document = url;
        doc.ref = newRef.fullPath;

        if (addToUser) {
          if (!this.newUser[section.key]) {
            this.newUser[section.key] = [];
          }

          this.newUser[section.key].push(doc);
        }

        this.saveUser(false, true);
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
        // this.$notify({ ... }); // optional notification
      } finally {
        this.loading = false;
      }
    },
    async deleteDoc() {
      this.deleteDocDialog = false;

      let res = await this.deleteDocFromStorage(
        this.newUser[this.selectedSection.key][this.deleteIndex],
      );

      this.newUser[this.selectedSection.key].splice(this.deleteIndex, 1);

      this.saveUser(false, true);
    },
    async deleteDocFromStorage(doc) {
      try {
        let newRef = ref(storage, doc.ref);

        this.loading = true;
        await deleteObject(newRef);
        this.loading = false;
      } catch (error) {
        console.log("Storage Delete Doc Error: ", error);
      }
    },
    viewDoc(url) {
      window.open(url, "_blank");
    },
    addSpeciality() {
      if (!this.speciality) {
        this.promptMessage = "Please enter a speciality!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.addingSpeciality = false;

      if (!this.newUser.speciality) {
        this.newUser.speciality = [];
      }

      this.newUser.speciality.push(this.speciality);
      this.specialities = this.newUser.speciality;

      this.speciality = null;
    },
    removeSpeciality() {
      this.specialities = this.newUser.speciality;
    },
  },
  async created() {
    // this.redirectToPayFast();

    this.getCompanies();
    this.getProfessions();

    if (
      this.newUser.userType == "Doctor" &&
      !this.newUser.clientAgePreference
    ) {
      this.newUser.clientAgePreference = [];
      this.newUser.clientAgePreference.push(0);
      this.newUser.clientAgePreference.push(100);
    }

    if (!this.newUser.tncAccepted) {
      this.showTnCDialog = true;
    } else {
      this.tncAccepted = true;
    }
  },
};
</script>

<style scoped>
.bg {
  width: 100%;
  min-height: 100vh;
  background-image: url("../assets/images/background.png");
  background-size: cover;
  background-attachment: fixed;
  /* Keeps background fixed in place */
  background-position: center center;
}

/* Card container: flex column with fixed max-height for inner scroll */
.white-card {
  width: 100%;
  max-width: 800px;
  /* Centering width */
  margin-top: -15px;
  /* Pull up card over background */
  border-radius: 0 0 20px 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  /* Softer shadow */
  background-color: white;
  max-height: 90vh;
  /* Keep card within viewport */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: scroll;
  /* Hide overflow, allow inner scroll */
}

/* Header area: does not scroll */
.card-header {
  padding: 16px;
  flex: 0 0 auto;
}

/* Body area: scrollable */
.card-body {
  flex: 1 1 auto;
  padding: 0 16px;
}

/* Each step content needs some bottom padding */
.step-content {
  padding-bottom: 16px;
}

/* Footer area: sticky at bottom of card */
.card-footer {
  flex: 0 0 auto;
  padding: 16px;
  background-color: white;
  border-top: 1px solid #e0e0e0;
}

/* Navigation button row spacing */
.navigation-btns {
  margin-top: 8px;
}

/* Buttons styling */
.nav-btn {
  width: 240px;
  /* Fixed width */
  height: 40px;
  /* Fixed height */
  font-weight: 500;
  text-transform: none;
}

.pink-btn {
  background-color: #e022d1 !important;
  width: 100%;
  max-width: 240px;
  /* Consistent button sizing */
}

/* Form controls spacing */
.v-text-field,
.v-select,
.v-file-input,
.v-radio-group {
  margin-top: 12px;
  /* Uniform top margin */
}

.info-text {
  color: grey;
}

.fs700 {
  font-size: 0.875rem;
}

/* Language grid styling */
.language-grid {
  display: flex;
  justify-content: center;
  /* Center cards */
  flex-wrap: wrap;
  gap: 16px;
  /* Space between cards */
  margin-top: 16px;
}

.language-card {
  cursor: pointer;
  transition: transform 0.2s ease;
  width: 120px;
  /* Constrain width */
  height: 60px;
  /* Fixed height */
  display: flex;
  align-items: center;
  justify-content: center;
}

.language-card:hover {
  transform: translateY(-4px);
}

.language-card.selected {
  background-color: #4390c0 !important;
  color: white !important;
}

/* Certification panel headings */
.v-card > h2 {
  font-weight: 600;
}

/* List spacing for certificate names */
.v-list-item {
  padding-left: 0;
  padding-right: 0;
}

/* Selected card outline */
.selected {
  border: 2px solid #4390c0 !important;
}

/* Accent color */
.blue-color {
  color: #4390c0;
}

/* Back to Login white text */
.white-color {
  color: white;
}

.avatar-label {
  display: inline-block;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 2px dashed #ccc;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  line-height: 150px;
  color: #888;
  background: #f9f9f9;
}

.avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  font-size: 14px;
  padding: 10px;
}
</style>
